import * as React from "react";
import { Navigate } from "react-router";

import { useAuth } from "./UseAuth.jsx";

export const AuthRoute = ({ children }) => {
  const { authed } = useAuth();

  if (authed) {
    return children;
  }

  if (authed === false) {
    return <Navigate to="/" replace />;
  }

  return <div>Login in progress...</div>;
};
